import React, { Fragment } from 'react';
import { Text, View, Platform } from 'react-native';
import { useTranslation } from 'react-i18next';
import ProductItem from 'components/ProductItem';
import OrderDetailListProps from 'types/components/OrderDetailListProps';
import { styles } from 'styles/components/orderDetailList';
import ProductType from 'types/enums/ProductType';
import OrderDetail from 'types/models/OrderDetail';

const isWeb = Platform.OS === 'web';
const WrapperComponent = isWeb ? Fragment : View;
const wrapperProps = isWeb ? {} : { style: styles.productItemShadow };

export default React.memo(
  ({
    detail,
    showControlQuantity,
    onChangeQuantity,
    onDeleteProduct,
    isForTotemDisplay,
    isModalCart,
    checkTomorrowGlobalRelationQuantityOnShoppingCartItems,
  }: OrderDetailListProps): JSX.Element => {
    const { t } = useTranslation();
    const [actionsEnabled, setActionsEnabled] = React.useState<boolean | undefined>(undefined);

    return (
      <View style={[styles.container, isModalCart && { width: '100%' }]}>
        <Text
          style={[
            styles.subTitle,
            isForTotemDisplay && {
              fontWeight: '500',
              fontSize: 48,
              lineHeight: 20,
              textTransform: 'capitalize',
              letterSpacing: 0.1,
              marginLeft: 30,
              marginBottom: 100,
              color: '#000000',
            },
          ]}
        >
          {isModalCart !== true &&
            `${t(isForTotemDisplay ? 'products-shopping-cart' : 'order-resume')} ${
              !isForTotemDisplay ? `(${detail.length})` : ''
            }`}
        </Text>
        {detail
          .filter((el) => el.product.typeId !== ProductType.Guarnicion && el.product.typeId !== ProductType.Extra)
          .map((detailItem) => (
            <WrapperComponent key={detailItem.product.id} {...wrapperProps}>
              <ProductItem
                product={detailItem.product}
                clothingSize={detailItem.clothingSize}
                textPriceColor={'#89909b'}
                initialQuantity={detailItem.quantity}
                showControlQuantity={showControlQuantity}
                onChangeQuantity={onChangeQuantity}
                onDeleteProduct={onDeleteProduct}
                actionsEnabled={actionsEnabled}
                setActionsEnabled={setActionsEnabled}
                tomorrowGlobalRelationQuantityOnShoppingCartItems={
                  checkTomorrowGlobalRelationQuantityOnShoppingCartItems
                    ? checkTomorrowGlobalRelationQuantityOnShoppingCartItems(
                        detailItem.product?.tomorrowGlobalProduct?.id,
                      )
                    : undefined
                }
                tomorrowQuantityBenefit={(detailItem as OrderDetail).tomorrowQuantityBenefit}
                productUnits={detailItem.quantity}
              />
            </WrapperComponent>
          ))}
      </View>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.detail.length !== nextProps.detail.length) {
      return false;
    }
    prevProps.detail.forEach((_value, index, arr) => {
      if ('product' in arr[index] && arr[index].product.id !== nextProps.detail[index].product.id) {
        return false;
      }

      if (
        'product' in arr[index] &&
        arr[index].product.id === nextProps.detail[index].product.id &&
        arr[index].quantity !== nextProps.detail[index].quantity
      ) {
        return false;
      }
    });
    return (
      prevProps.showControlQuantity === nextProps.showControlQuantity &&
      prevProps.onChangeQuantity === nextProps.onChangeQuantity &&
      prevProps.onDeleteProduct === nextProps.onDeleteProduct
    );
  },
);
